import { Flat } from "./flat.js";
import {Utility} from "../utility.js";

export class ServeAFeast extends Flat{
    static info = {
        key: "serve-a-feast",
        name: "Help grandma prepare a feast",
        description: "Grandma has prepared a delicious feast for the Lunar New Year reunion dinner and needs your help to serve the guests. Make sure to only serve lucky Lunar New Year food!",
        logo: { x: 860, y: 520 },
        won: false
    }
    constructor(key, level, options){
        super(key, level, {...options, x: 2400, y: 1958, holder: true, bobInRed: true })
        this._kitchenObjects = [
            {
                name: "hg-obstacle-a",
                positions: {"left": 887, "top": 1147},
            },
            {
                name: "hg-obstacle-b",
                positions: {"left": 918, "top": 1318},
            },
            {
                name: "hg-obstacle-c",
                positions: {"left": 2865, "top": 1346},
            }
        ]
        this._pickables = {
            group: null,
            list: [
                {
                    "name": "hg-fish",
                    peipei: {
                        take: "You selected fish!",
                        drop: "Nice job! Fish means an increase in prosperity.",
                    },
                    "position": {"left": 1685, "top": 2100},
                    "destinations": {
                        "name": "hg-table",
                        "x": 618,
                        "y": 1525
                    }
                },
                {
                    "name": "hg-chicken",
                    peipei: {
                        take: "You selected chicken!",
                        drop: "Whoo hoo! Serving a whole chicken is a sign of abundance!",
                    },
                    "position": {"left": 1845, "top": 1960},
                    "destinations": {
                        "name": "hg-table",
                        "x": 621,
                        "y": 1753
                    }
                },
                {
                    "name": "hg-noodles",
                    peipei: {
                        take: "You selected noodles!",
                        drop: "Great work! Noodles symbolize longevity, meaning long life.",
                    },
                    "position": {"left": 1315, "top": 2043},
                    "destinations": {
                        "name": "hg-table",
                        "x": 646,
                        "y": 1867
                    }
                },
                {
                    "name": "hg-shrimp",
                    peipei: {
                        take: "You selected shrimp!",
                        drop: "Nice work! Shrimp sounds like “smile” in Chinese and symbolizes happiness!",
                    },
                    "position": {"left": 2005, "top": 2100},
                    "destinations": {
                        "name": "hg-table",
                        "x": 623,
                        "y": 1978
                    }
                },
                {
                    "name": "hg-dumplings",
                    peipei: {
                        take: "You selected dumplings!",
                        drop: "Hooray! Dumplings are shaped like ancient silver and gold which symbolize wealth.",
                    },
                    "position": {"left": 2641, "top": 2181},
                    "destinations": {
                        "name": "hg-table",
                        "x": 647,
                        "y": 1644
                    }
                },
                {
                    "name": "hg-cheese",
                    peipei: {
                        take: "You selected cheese!",
                        drop: "Oops...That’s not a lucky food!",
                    },
                    "position": {"left": 1320, "top": 2181},
                },
                {
                    "name": "hg-hotdog",
                    peipei: {
                        take: "You selected hot dog!",
                        drop: "Oops...That’s not a lucky food!",
                    },
                    "position": {"left": 2641, "top": 2048},
                },
                {
                    "name": "hg-muffin",
                    peipei: {
                        take: "You selected muffin!",
                        drop: "Oops...That’s not a lucky food!",
                    },
                    "position": {"left": 2065, "top": 1960},
                },
                {
                    "name": "hg-pizza",
                    peipei: {
                        take: "You selected pizza!",
                        drop: "Oops...That’s not a lucky food!",
                    },
                    "position": {"left": 1685, "top": 1960},
                }
            ]
        }
        this._guests = [
            {
                name: "hg-final-adult-1",
                anim: "final-adult-1",
                x: 463,
                y: 1739,
                width: 131,
                height: 165
            },
            {
                name: "hg-final-adult-2",
                anim: "final-adult-2",
                x: 470,
                y: 1928,
                width: 127,
                height: 165
            },
            {
                name: "hg-final-adult-3",
                anim: "final-adult-3",
                x: 936,
                y: 1736,
                width: 129,
                height: 169
            },
            {
                name: "hg-final-bob",
                anim: "final-bob",
                x: 940,
                y: 1565,
                width: 118,
                height: 144
            },
            {
                name: "hg-final-grandma",
                anim: "final-grandma",
                x: 930,
                y: 1900,
                width: 144,
                height: 206
            },
            {
                name: "hg-final-kid-1",
                anim: "final-kid",
                x: 455,
                y: 1547,
                width: 120,
                height: 169
            },
        ]
        this._table = null
        this._dinnerDisheslength = null
        this._scorePoint = null
        this._dishOnTable = 0
        this._grandma = null
        this._grandmaBubble = {container: null, started: null}
        this._grandmaGreetings = ["Let's prepare dinner with all the lucky foods!", "Let's prepare our lucky LNY feast for the family!"]
    }
    preload(){
        super.preload()
        this._kitchenObjects.forEach(w => this.load.image(w.name, `assets/serve-a-feast/objects/${w.name}.png`))
        this._pickables.list.forEach(d => this.load.image(d.name, `assets/serve-a-feast/dishes/${d.name}.png`))
        this.load.image("hg-table", "assets/serve-a-feast/objects/hg-table.png")
        this.load.image("hg-adult-grandma", "assets/serve-a-feast/objects/hg-adult-grandma.png")
        this._guests.forEach(g => this.load.spritesheet(`${g.anim}`, `assets/serve-a-feast/guests/${g.name}.png`, {
            frameWidth: g.width,
            frameHeight: g.height
        }))
    }
    create(){
        super.create()
        this._table = this.add.image(500, 1487, "hg-table").setOrigin(0,0)
        this._grandma = this.physics.add.staticImage(2361, 2167, "hg-adult-grandma").setOrigin(0,0).refreshBody()
        let kitchenObjects = this.physics.add.staticGroup()
        this._kitchenObjects.forEach(o => {
            let so = kitchenObjects.create(o.positions.left, o.positions.top, o.name).setOrigin(0).refreshBody()
            so.setSize(so.body.width, so.body.height - 155, false)
        })
        this.physics.add.collider(this.bob, [kitchenObjects, this._furniture, this._grandma])
        this._pickables.group = this.physics.add.staticGroup()
        this._pickables.list.forEach(d => this._pickables.group.create(d.position.left, d.position.top, d.name).setOrigin(0, 0).refreshBody())
        this.peiPeiSay("Let’s help grandma bring lucky dishes to the table!")
        
        this._dinnerDisheslength = this._pickables.list.filter(t => typeof t.destinations !== "undefined").length
        this._scorePoint = this._dinnerDisheslength * this._GAME_ACTION_POINT
        this.board.score.setText(`0/${this._scorePoint}`)
    }
    update(time, delta){
        super.update(time, delta)
        this.updateGrandmaBubble()
    }
    onSpace(){
        const pickDish = () => {
            const overlaps = this._pickables.group.children.entries.filter(d => this.physics.overlapRect(d.x-20, d.y-20, d.width+40, d.height+40, true, false).length !== 0)
            if (overlaps.length === 0) return
            this._holder.back().take(overlaps[0])
        }
        pickDish()

        const putDish = () => {
            if (!this._holder.holding()) return
            // Check if the dish could be put down
            const overlaps = this.physics.overlapRect(this._table.x - 20, this._table.y - 20, this._table.width + 40, this._table.height + 40, true, false)
            if (overlaps.length !== 1) return
            const targetDish = this._pickables.list.filter(d => d.name === this._holder.item.texture.key )
            if ( !targetDish[0].destinations ) {
                this.peiPeiSay("Oops...That’s not a lucky food Go pick another dish!")
                this.sound.play("wrong")
                this._holder.back()
                return
            }
            // Put it down
            this._holder.drop(targetDish[0].destinations)
            this._dishOnTable++
            this.sound.play("right")
            let score = this.board.score.text
            this.board.score.setText(`${parseInt(score) + 5}/${this._scorePoint}`)
            // Check if won
            if (this._dishOnTable === this._dinnerDisheslength) {
                this.peiPeiSay("Mission accomplished!")
                this.doGuestAnimation()
                this.bob.setVisible(false)
                this._grandma.destroy()
                this.time.addEvent({ delay: 4000, callback: ()=> {this.win(this.board.score.text)}, callbackScope: this })
            }
        }
        putDish()

        const chatWithGrandma = () => {
            const overlaps = this.physics.overlapRect(this._grandma.x - 20, this._grandma.y - 20, this._grandma.width + 40, this._grandma.height + 40, true, false)
            if (overlaps.length === 0) return
            const greeting = this._grandmaGreetings[Math.floor(Math.random() * this._grandmaGreetings.length)];
            this.grandmaSay(greeting, overlaps[0].center.x, overlaps[0].center.y)
        }
        chatWithGrandma()
    }
    doGuestAnimation(){
        this._guests.forEach(g => this.anims.create({
            key: `${g.anim}`,
            frames: this.anims.generateFrameNumbers(`${g.anim}`, {start: 0, end: 7}),
            frameRate: 8,
            repeat: 3,
            hideOnComplete: false
        }))

        this._guests.forEach(g => this.add.sprite(g.x, g.y, `${g.anim}`).play(g.anim))
    }
    grandmaSay(msg, x, y) {
        let text = Utility.make.text(this, 30, 15, msg,  {
            fontSize: "40px"
        })
        let w = text.width + 60
        let panel = this.add.graphics()
            .fillStyle(0x070b34, 1)
            .fillRoundedRect(0, 0, w, 80, 20)
        if (this._grandmaBubble.container) this._grandmaBubble.container.destroy()
        this._grandmaBubble.container = this.add.container(x - w/2, y - 200).setDepth(220)
        this._grandmaBubble.container.width = w
        this._grandmaBubble.container.height = 80
        this._grandmaBubble.container.add([panel, text])
        this.sound.play("speech")
        this._grandmaBubble.started = Date.now()
    }
    updateGrandmaBubble(){
        let b = this._grandmaBubble
        if (!b.container) return
        if (Date.now() - b.started > 2000) {
            b.container.destroy()
            b.container = null
        }
    }
}